import React from "react";
import { Stack } from "@mui/material";

import { useGetOutboundOrders } from "../../hooks";
import { HubTableTemplate } from "../../components";

import OutboundOrdersContextMenu from "./OutboundOrdersContextMenu";
import { items, keys } from "./helper";
import OrdersV2LineItemsTable from "../OrdersTable/OrdersV2LineItemsTable";

export const OutboundOrdersTable = ({
  defaultLocation = 1,
  setPoNumber = () => { },
}) => {
  const { data, isLoading } = useGetOutboundOrders({ defaultLocation });

  const headerProps = { items, includeCheckbox: true, includeEnd: true, includeChevron: true };
  const bodyProps = {
    items: data?.rows,
    keys, 
    includeChevron: true,
    ContextMenu: ({ ...rest }) => (
      <OutboundOrdersContextMenu {...rest} setPoNumber={setPoNumber} />
    ),
    RenderElement: OrdersV2LineItemsTable
  };

  const props = {
    headerProps,
    bodyProps,
    meta: { ...data?.meta },
    isLoading,
  };

  return (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="OutboundOrdersTable" {...props} />
    </Stack>
  );
};

export default OutboundOrdersTable;
